<template>

    <div>

        <el-dialog title="导出Excel" width="80%" :visible="kpiResultExportDialogVisible" @close="close" center>
            <el-form :model="form_kpi_result_export" ref="form_kpi_result_export" label-width="85px"
                     class="demo-ruleForm">
                <el-row>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                        <el-form-item label="数据中心">
                            <dept-select size="mini" :allowAll="true" class="width100"
                                         multiple="true" v-model="form_kpi_result_export.depts">
                            </dept-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                        <el-form-item label="职级">
                            <el-select multiple="true"
                                       collapse-tags="true"
                                       size="mini"
                                       class="width100"
                                       v-model="form_kpi_result_export.levels" placeholder="请选择">
                                <el-option
                                        v-for="item in levelArr"
                                        :key="item.value"
                                        :label="item.desc"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                        <el-form-item label="月份从" prop="content">
                            <el-date-picker
                                    size="mini"
                                    v-model="form_kpi_result_export.startdate"
                                    type="month"
                                    value-format="yyyy-MM-dd"
                                    placeholder="月份从">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                        <el-form-item label="至" prop="result">
                            <el-date-picker
                                    size="mini"
                                    v-model="form_kpi_result_export.enddate"
                                    type="month"
                                    value-format="yyyy-MM-dd"
                                    placeholder="至">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row style="text-align: center">
                    <el-button center="true" type="primary" @click="exportExcel">确 定</el-button>
                    <el-button center @click="close">关 闭</el-button>
                </el-row>

            </el-form>
        </el-dialog>

    </div>

</template>


<script>

    import DeptSelect from '@/components/dept'
    import KpiServer from '@/api/kpi/index'
    import {formatDate} from 'element-ui/lib/utils/date-util'
    import {createNamespacedHelpers} from "vuex";
    import AthubCloudApi from "../../api/athubCloud";

    const deptNSHelper = createNamespacedHelpers("dept");

    export default {

        name: "KpiResultExportDialog",

        props: ['kpiResultExportDialogVisible'],

        components: {
            DeptSelect,
        },

        data() {
            return {

                form_kpi_result_export: {
                    depts: [],
                    startdate: '',
                    enddate: '',
                    levels: [],
                },

                levelArr: [
                    {
                        value: '1',
                        desc: 'G1'
                    },
                    {
                        value: '2',
                        desc: 'G2'
                    },
                    {
                        value: '3',
                        desc: 'G3'
                    },
                    {
                        value: '4',
                        desc: 'G4'
                    }, {
                        value: '5',
                        desc: 'G5'
                    }, {
                        value: '6',
                        desc: 'G6'
                    }, {
                        value: '7',
                        desc: 'G7'
                    },
                ],

            }
        },

        methods: {

            initFormData() {
                this.form_kpi_result_export = {};
            },

            close() {
                this.$emit('update:kpiResultExportDialogVisible', false);
            },

            async exportExcel() {

                let fileName = '绩效考评导出.xlsx';

                let deptIds = [];
                if (this.form_kpi_result_export.depts == null || this.form_kpi_result_export.depts.length == 0) {
                    let deptInfo = await AthubCloudApi.fetchDeptListByAuthSites();
                    deptIds = deptInfo.map(e => e.id);
                } else {
                    deptIds = this.form_kpi_result_export.depts;
                }

                await KpiServer.kpiResult.exportExcel({
                    kpiDto: {
                        depts: deptIds,
                        startdate: this.form_kpi_result_export.startdate,
                        enddate: this.form_kpi_result_export.enddate,
                        status: 'CLOSE',
                    },
                    levels: this.form_kpi_result_export.levels,
                }).then(responseBody => {
                    let blob = responseBody;
                    let reader = new FileReader();
                    reader.readAsDataURL(blob);
                    reader.onload = function (e) {
                        var a = document.createElement('a');
                        a.download = fileName;
                        a.href = e.target.result;
                        $("body").append(a);
                        a.click();
                        $(a).remove();
                    }
                    this.$emit('update:kpiResultExportDialogVisible', false);
                });
            },

        },

        watch: {},

        computed: {
            ...deptNSHelper.mapGetters(['deptSource$']),
        },

        mounted() {

            this.deptSource$.subscribe(v => {
                // if (v != null && v.length > 0) {
                //     v.forEach(e => {
                //         this.form_kpi_result_export.depts.push(e.id);
                //     })
                // }
                // this.form_kpi_result_export.depts.push("-1");
            });

            this.form_kpi_result_export.levels = ['1', '2', '3', '4'];

            this.form_kpi_result_export.startdate = formatDate(new Date(), 'yyyy-MM-dd');
            this.form_kpi_result_export.enddate = formatDate(new Date(), 'yyyy-MM-dd');

        },


    }

</script>